export default {"src":"/_next/static/media/project-logo-sharmila.e73809ab.svg","height":48,"width":290,"blurWidth":0,"blurHeight":0};